var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBmi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2483FF37-DBB7-410F-8C49-8B2A761EB62D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hilbi-WebApp-Desktop-ChatDetail",
    transform: "translate(-540.000000, -218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(516.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(24.000000, 97.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BMI",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z M6.69641809,8 L4,8 L4,14 L6.77862595,14 C7.40888628,14 7.90761401,13.8525281 8.27480916,13.5575843 C8.64200431,13.2626404 8.82560188,12.8623596 8.82560188,12.3567416 C8.82560188,11.991573 8.73243296,11.6825843 8.54609513,11.4297753 C8.35975729,11.1769663 8.09669211,11 7.75689959,10.8988764 C8.04188687,10.7921348 8.26521824,10.6207865 8.42689372,10.3848315 C8.58856919,10.1488764 8.66940693,9.87359551 8.66940693,9.55898876 C8.66940693,9.0758427 8.49266001,8.69522472 8.13916618,8.41713483 C7.82985907,8.17380618 7.42299435,8.03693381 6.91857201,8.00651773 L6.69641809,8 Z M10.7574868,8 L9.73810922,8 L9.73810922,14 L10.864357,14 L10.864357,10.7640449 L12.2207868,14 L13.0510863,14 L14.3992954,10.7219101 L14.3992954,14 L15.5337639,14 L15.5337639,8 L14.5226072,8 L12.6482678,12.4241573 L10.7574868,8 Z M18,8 L16.7175573,8 L16.7175573,14 L18,14 L18,8 Z M6.63065179,11.4550562 C6.97592484,11.4550562 7.22665884,11.5168539 7.38285379,11.6404494 C7.53904874,11.7640449 7.61714621,11.9606742 7.61714621,12.2303371 C7.61714621,12.494382 7.53904874,12.6867978 7.38285379,12.8075843 C7.22665884,12.9283708 6.97592484,12.988764 6.63065179,12.988764 L5.2495596,12.988764 L5.2495596,11.4550562 L6.63065179,11.4550562 Z M6.48267763,9.01123596 C6.8115091,9.01123596 7.05676258,9.07022472 7.21843805,9.18820225 C7.38011353,9.30617978 7.46095126,9.48876404 7.46095126,9.73595506 C7.46095126,9.97752809 7.38011353,10.1558989 7.21843805,10.2710674 C7.05676258,10.386236 6.8115091,10.4438202 6.48267763,10.4438202 L5.2495596,10.4438202 L5.2495596,9.01123596 L6.48267763,9.01123596 Z",
    id: "Combined-Shape",
    fill: "#181E34",
    opacity: 0.400000006
  }), /*#__PURE__*/React.createElement("g", {
    id: "BMI-3",
    transform: "translate(4.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BMI-2"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBmi);
export default __webpack_public_path__ + "static/media/icon-bmi.54ddb91bd3325ab8c18c84a7e1bdcc31.svg";
export { ForwardRef as ReactComponent };